import { VisuallyHidden } from '@reach/visually-hidden';

import { OrderInstruction } from '#/api/orders';

import ChevronDownIcon from '#/assets/ChevronDownIcon';

import Field from '#/components/shared/Field';

import {
  useOrderFormActions,
  useOrderFormView,
} from '#/features/perpetuals/order-builder/form-context';

import useLabel from '#/utils/useLabel';
import {
  ListboxInput,
  ListboxButton,
  ListboxPopover,
  ListboxList,
  ListboxOption,
} from '#/components/common/Listbox';

export default function InstructionSelect() {
  const [label, labelId] = useLabel('Instruction');
  const formActions = useOrderFormActions();
  const formView = useOrderFormView();

  return (
    <Field label={label} labelId={labelId}>
      <VisuallyHidden as="output" id={labelId}>
        {label}
      </VisuallyHidden>
      <ListboxInput
        aria-labelledby={labelId}
        onChange={(instruction) =>
          formActions.updateInstruction(instruction as OrderInstruction)
        }
        value={formView.instruction}
        label={formView.instructionLabel}
      >
        <ListboxButton arrow={<ChevronDownIcon />} />
        <ListboxPopover portal={false}>
          <ListboxList>
            {formView.instructionOptions.map((option) => (
              <ListboxOption
                key={option.value}
                value={option.value}
                disabled={option.selected}
              >
                {option.label}
              </ListboxOption>
            ))}
          </ListboxList>
        </ListboxPopover>
      </ListboxInput>
    </Field>
  );
}
